import React from 'react'
import onClickOutside from 'react-onclickoutside'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Icons, TextField } from '@120wateraudit/envirio-components'
import { Grid } from 'semantic-ui-react'
import styles from './ShareModal.module.scss'
import { Button } from '@120wateraudit/envirio-components/dist/components/Button'
import { Icon } from 'semantic-ui-react'

interface ShareModalProps {
  accountName?: string
  shareIsOpen: boolean
  onToggleModal(): void
}

interface ShareModalState {
  copied: boolean
  valueToCopy: string
}

class ShareModal extends React.Component<ShareModalProps, ShareModalState> {
  constructor(props: ShareModalProps) {
    super(props)

    this.state = {
      valueToCopy: window.location.href,
      copied: false
    }
  }

  handleClickOutside = () => {
    this.props.onToggleModal()
  }

  render() {
    const { valueToCopy, copied } = this.state

    return (
      <div className={styles.shareModal}>
        <div className={styles.modalHeader}>
          <h4>Share</h4>
          <button
            className={styles.exitButton}
            onClick={() => this.props.onToggleModal()}
          >
            &times;
          </button>
        </div>
        <p>Copy the link below to share this page.</p>
        <Grid>
          <Grid.Row columns="equal" style={{ paddingBottom: '0' }}>
            <Grid.Column>
              <TextField
                value={valueToCopy}
                onChange={({ target: { value } }: any) =>
                  this.setState({ valueToCopy: value, copied: false })
                }
                fluid
                style={{ width: '100%' }}
                placeholder="Dashboard URL"
                className={styles.locationInput}
                disabled
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={10}>
              {copied ? (
                <Button size="small" className={styles.copiedButton}>
                  Copied
                  <Icon name="checkmark" />
                </Button>
              ) : (
                <CopyToClipboard
                  text={this.state.valueToCopy}
                  onCopy={() => this.setState({ copied: true })}
                >
                  <Button size="small" className={styles.copyButton}>
                    Click to Copy
                    <Icon name="copy" />
                  </Button>
                </CopyToClipboard>
              )}
            </Grid.Column>

            <Grid.Column width={6}>
              <a href={this.buildShareEmail()}>
                <Button size="small" className={styles.emailButton}>
                  Email
                  <Icons.Email />
                </Button>
              </a>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
  }

  private buildShareEmail() {
    const { accountName } = this.props

    const baseEmail = 'mailto:'
    const subject = `${
      accountName !== undefined ? accountName + `'s ` : ''
    }Water Quality Dashboard`
    const body = `Checkout ${
      accountName !== undefined ? accountName + `'s ` : 'This'
    } Water Quality Dashboard Here: ${window.location}`

    return encodeURI(baseEmail + '?body=' + body + '&subject=' + subject)
  }
}

export default onClickOutside(ShareModal)
